export type InvoicingDetailsDTOItem =
  (typeof InvoicingDetailsDTOItem)[keyof typeof InvoicingDetailsDTOItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoicingDetailsDTOItem = {
  external_customer_id: 'external_customer_id',
  cost_center: 'cost_center',
  account: 'account',
  counterparty: 'counterparty',
  purpose: 'purpose',
  project: 'project',
  object: 'object',
  activity: 'activity',
  article: 'article',
} as const;
